import React, { Component } from 'react';
import lang from '../../../lang/index';

export default class IcardConfirmPopup extends Component {
    static defaultProps = {
        orderData:{}
    }
    constructor(props){
        super(props);
    }

    render() {
        return (
            <div className="popup-wrapper">
            <div className="box-hd">
                    <div className="title">
                        {lang.template('icard_popup_confirm_title')}
                    </div>
                    <div className="close" onClick={this.props.handleCancel}></div>
                </div>
            <div className="content">
                <div className="warning-tip">
                LƯU Ý:<br/>
                UPLIVE KHÔNG HỖ TRỢ CHO VIỆC NHẬP SAI NHÀ MẠNG VÀ MỆNH GIÁ THẺ.<br/>
                Xin hãy chọn thông tin chính xác để tránh mất thẻ.
                </div>
                    <div className="infos">
                        <p><span className="name-span">{lang.template('icard_cardType')}:</span> <span className="value-span">{this.props.type}</span></p>
                        <p><span className="name-span">{lang.template('icard_cardValue')}:</span> <span className="value-span">{this.props.value}</span></p>
                        <p><span className="name-span">{lang.template('icard_Serial')}:</span> <span className="value-span">{this.props.serial}</span></p>
                        <p><span className="name-span">{lang.template('icard_Code')}:</span> <span className="value-span">{this.props.code}</span></p>
                    </div>
                </div>
                <div className="box-fd">
                   <div className="mini-btn" onClick={this.props.handleCancel}>{lang.template('icard_popup_no')}</div>
                   <div className="mini-btn" onClick={this.props.handleConfirm}>{lang.template('icard_popup_yes')}</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/component/recharge/popup/icard-confirm.js